module.exports = __webpack_public_path__ + "img/img87.a3a1565b.png";